import ApplicationSerializer from 'eflex/serializers/application';

export default class CustomIdentifierDatumSerializer extends ApplicationSerializer {
  attrs = {
    buildStatus: {
      serialize: false,
      deserialize: false,
    },
    liveBuildStatus: {
      serialize: false,
      deserialize: false,
    },
  };
}
